import React from 'react';
interface Props {
    startDate: string;
    endDate: string;
    separator?: string;
}
const EventDate = ({ startDate, endDate, separator = '.' }: Props) => {
    const isSameDay = (a, b) => {
        return (
            a.getFullYear() === b.getFullYear() &&
            a.getMonth() === b.getMonth() &&
            a.getDate() === b.getDate()
        );
    };

    const isSameMonth = (a, b) => {
        return a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth();
    };
    const OStartDate = new Date(startDate);
    const OEndDate = new Date(endDate);

    if (isSameDay(OStartDate, OEndDate)) {
        return (
            <>{`${OStartDate.getDate()}${separator}${
                OStartDate.getMonth() + 1
            }${separator}${OStartDate.getFullYear()}`}</>
        );
    }

    if (isSameMonth(OStartDate, OEndDate)) {
        return (
            <>{`${OStartDate.getDate()}-${OEndDate.getDate()}${separator}${
                OStartDate.getMonth() + 1
            }${separator}${OStartDate.getFullYear()}`}</>
        );
    }

    return (
        <>{`${OStartDate.getDate()}${separator}${
            OStartDate.getMonth() + 1
        }${separator}${OStartDate.getFullYear()}-${OEndDate.getDate()}${separator}${
            OEndDate.getMonth() + 1
        }${separator}${OEndDate.getFullYear()}`}</>
    );
};

export default EventDate;
